
import React from "react";
import { Editor } from "@tiptap/react";
import { Bold, Italic, Underline, List, ListOrdered, Code } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import MenuButton from "../MenuButton";

interface TextFormatToolsProps {
  editor: Editor;
}

const TextFormatTools = ({ editor }: TextFormatToolsProps) => {
  return (
    <>
      <MenuButton 
        onClick={() => editor.chain().focus().toggleBold().run()} 
        icon={<Bold className="h-4 w-4" />} 
        tooltip="Bold (Ctrl+B)"
        isActive={editor.isActive('bold')}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().toggleItalic().run()} 
        icon={<Italic className="h-4 w-4" />} 
        tooltip="Italic (Ctrl+I)"
        isActive={editor.isActive('italic')}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().toggleUnderline().run()} 
        icon={<Underline className="h-4 w-4" />} 
        tooltip="Underline (Ctrl+U)"
        isActive={editor.isActive('underline')}
      />
      
      <div className="h-8 w-px bg-border mx-1" />
      
      <MenuButton 
        onClick={() => editor.chain().focus().toggleBulletList().run()} 
        icon={<List className="h-4 w-4" />} 
        tooltip="Bullet List"
        isActive={editor.isActive('bulletList')}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().toggleOrderedList().run()} 
        icon={<ListOrdered className="h-4 w-4" />} 
        tooltip="Ordered List"
        isActive={editor.isActive('orderedList')}
      />
      
      <div className="h-8 w-px bg-border mx-1" />
    </>
  );
};

export default TextFormatTools;
